/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-29 10:05:09
 * @LastEditors: yd
 * @LastEditTime: 2020-09-07 18:06:37
 */
import http from '../httpConfig'
const table = 'mrbase_sys_org_levels'
//选人 

//请求当前公司组织 
export const getChooseStaffTreeList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/select/list-organization/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//根据公司或者部门uid获取员工数据
export const getStaffList = (params = {}) => {
  params['~table~'] = 'mrbase_sys_staffs'
  return new Promise((resolve, reject) => {
    http.post('/api/select/list-department/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//根据公司或者部门uid获取岗位数据
export const getPositionList = (params = {}) => {
  params['~table~'] = 'mrbase_sys_job_posts'
  return new Promise((resolve, reject) => {
    http.post('/api/select/list-department/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//保存my组
export const addMyGroup = (params = {}) => {
  params['~table~'] = 'mrbase_sys_group'
  return new Promise((resolve, reject) => {
    http.post('/api/select/save-personage-the-group/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}



//查看组详情
export const getDetailGroup = (params = {}) => {
  params['~table~'] = 'mrbase_sys_group'
  return new Promise((resolve, reject) => {
    http.post('/api/select/get-the-group/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//删除my组
export const deleteGroup = (params = {}) => {
  params['~table~'] = 'mrbase_sys_group'
  return new Promise((resolve, reject) => {
    http.post('/api/select/delete-the-group/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//获取已经保存的组织架构
export const getSaveOrganization = (params = {}) => {
  params['~table~'] = 'mrbase_sys_organizational_structure_storage'
  return new Promise((resolve, reject) => {
    http.post('/api/select/get-at-present-organization/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//保存当前已选择的组织架构
export const addSaveOrganization = (params = {}) => {
  params['~table~'] = 'mrbase_sys_organizational_structure_storage'
  return new Promise((resolve, reject) => {
    http.post('/api/select/save-organization/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


//获取组列表
export const getGroupList = (params = {}) => {
  params['~table~'] = 'mrbase_sys_group'
  return new Promise((resolve, reject) => {
    http.post('/api/select/list-all-group/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
} 